import BaseParagraph from 'antd/es/typography/Paragraph';
import { ReactNode, useMemo } from 'react';
import styled from 'styled-components';

import { cBC44FF, cCC38FF } from '#/colors';

interface Props {
  readonly children: ReactNode;
  readonly maxRows: number;
}

const EXPAND_LABEL = 'read more';

export default function ShowMoreText(props: Props) {
  const settings = useMemo(
    () => ({
      rows: props.maxRows,
      expandable: true,
      symbol: EXPAND_LABEL,
    }),
    [props.maxRows],
  );

  return <Paragraph ellipsis={settings}>{props.children}</Paragraph>;
}

const Paragraph = styled(BaseParagraph)`
  &.ant-typography {
    margin: 0;
    color: inherit;
    line-height: inherit;
    font: inherit;

    .ant-typography-expand {
      color: ${cCC38FF};
    }

    a {
      color: ${cBC44FF};
    }
  }
`;
